import React from "react";
import { motion } from "framer-motion";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import WhatsAppRoundedIcon from "@mui/icons-material/WhatsApp";
import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";

const MotionBox = motion(Box);

const cards = [
  {
    title: "Atención por WhatsApp",
    description:
      "Escríbenos de forma directa para resolver dudas sobre inscripciones, planes y disponibilidad.",
    icon: <WhatsAppRoundedIcon sx={{ fontSize: { xs: 24, md: 26 } }} />,
  },
  {
    title: "Horarios e información",
    description:
      "Te ayudamos a conocer nuestros horarios y todo lo necesario para que elijas la mejor opción para ti.",
    icon: <ScheduleRoundedIcon sx={{ fontSize: { xs: 24, md: 26 } }} />,
  },
  {
    title: "Asesoría cercana",
    description:
      "Recibe una atención clara y rápida para dar el siguiente paso y unirte al equipo NovaXFit.",
    icon: <SupportAgentRoundedIcon sx={{ fontSize: { xs: 24, md: 26 } }} />,
  },
];

export default function GymCardsSection() {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 4.5, md: 6.5 },
        bgcolor: "#ffffff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: { xs: -80, md: -120 },
          right: { xs: -90, md: -120 },
          width: { xs: 180, md: 260 },
          height: { xs: 180, md: 260 },
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(229,9,20,0.12) 0%, rgba(229,9,20,0) 70%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: -70, md: -100 },
          left: { xs: -80, md: -100 },
          width: { xs: 160, md: 220 },
          height: { xs: 160, md: 220 },
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0) 70%)",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={{ xs: 1.8, sm: 2.2, md: 2.6 }} justifyContent="center">
          {cards.map((card, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={card.title}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <MotionBox
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.55, delay: index * 0.1 }}
                whileHover={{ y: -8 }}
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Card
                  elevation={0}
                  sx={{
                    width: "100%",
                    maxWidth: { xs: 320, sm: 300, md: 295 },
                    minHeight: { xs: 220, sm: 228, md: 236 },
                    borderRadius: { xs: "18px", md: "20px" },
                    border: "1px solid rgba(0,0,0,0.07)",
                    background:
                      "linear-gradient(180deg, #ffffff 0%, #fbfbfb 100%)",
                    boxShadow: {
                      xs: "0 8px 20px rgba(0,0,0,0.05)",
                      md: "0 14px 32px rgba(0,0,0,0.07)",
                    },
                    backdropFilter: "blur(6px)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    transition:
                      "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 18px 38px rgba(0,0,0,0.10)",
                      borderColor: "rgba(229,9,20,0.16)",
                    },
                  }}
                >
                  <CardContent sx={{ p: { xs: 2, md: 2.3 } }}>
                    <Stack spacing={{ xs: 1.5, md: 1.8 }}>
                      <Box
                        sx={{
                          width: { xs: 48, md: 52 },
                          height: { xs: 48, md: 52 },
                          borderRadius: { xs: "14px", md: "15px" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          bgcolor: "#e50914",
                          color: "#ffffff",
                          boxShadow: "0 10px 22px rgba(229,9,20,0.22)",
                        }}
                      >
                        {card.icon}
                      </Box>

                      <Typography
                        sx={{
                          fontSize: { xs: 17, md: 18 },
                          fontWeight: 900,
                          color: "#111111",
                          letterSpacing: -0.4,
                          lineHeight: 1.2,
                        }}
                      >
                        {card.title}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: { xs: 13.2, md: 13.8 },
                          lineHeight: { xs: 1.62, md: 1.68 },
                          color: "rgba(17,17,17,0.72)",
                          fontWeight: 500,
                        }}
                      >
                        {card.description}
                      </Typography>
                    </Stack>
                  </CardContent>

                  <Box
                    sx={{
                      px: { xs: 2, md: 2.3 },
                      pb: { xs: 1.5, md: 1.7 },
                    }}
                  >
                    <Box
                      sx={{
                        height: 3,
                        width: "100%",
                        borderRadius: "999px",
                        background:
                          "linear-gradient(90deg, rgba(229,9,20,1) 0%, rgba(229,9,20,0.55) 100%)",
                      }}
                    />
                  </Box>
                </Card>
              </MotionBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}